import {
  Breadcrumb, Button, Card, Container,
} from 'nhsuk-react-components';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchTeamRoutingPlans from 'queries/fetch/fetchTeamRoutingPlans';
import ProgressIndicator from 'components/ProgressIndicator';
import { getLatestRoutingPlans } from 'utils/routingPlansUtils';
import TeamDetailsSection from '../TeamDetailsSection';
import RoutingPlansTable from './RoutingPlansTable';

function TeamRoutingPlansPage() {
  const { teamId } = useParams() as { teamId: string };
  const navigate = useNavigate();

  const { data, isLoading, error } = useFetchTeamRoutingPlans({ teamId });

  const latestRoutingPlans = data ? getLatestRoutingPlans(data) : [];

  const handleAddToList = () => {
    navigate(`/admin/${teamId}/team-message-plans/add`);
  };

  const handleChangeTargets = () => {
    navigate(`/admin/${teamId}/team-message-plans/change-targets`);
  };

  return (
    <Container>
      <div className="nhsuk-u-margin-bottom-6">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/admin">
            Admin home
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span aria-current="page">Team message plans</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Card>
        <>
          <h1
            role="main"
            className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
          >
            Team message plans
          </h1>
          <TeamDetailsSection teamId={teamId} />
          <p className="nhsuk-u-font-weight-bold">Message plan list</p>
          <p>
            Below is a list of your current message plans for this team.
            To add more to this list press the Add to list button.
          </p>
          <div className="nhsuk-u-float-right nhsuk-u-margin-bottom-3">
            <Button
              login
              onClick={handleAddToList}
              className="nhsuk-u-margin-bottom-3 nhsuk-u-margin-right-3"
            >
              Add to list
            </Button>
            <Button
              secondary
              onClick={handleChangeTargets}
              className="nhsuk-u-margin-bottom-3"
            >
              Change targets
            </Button>
          </div>

          {isLoading && <ProgressIndicator text="Loading message plans..." />}
          {error && <p className="nhsuk-error-message">Could not get message plans</p>}
          {!error && latestRoutingPlans.length > 0 ? (
            <RoutingPlansTable
              routingPlans={latestRoutingPlans}
            />
          ) : (
            !isLoading && !error && <p className="nhsuk-u-font-weight-bold nhsuk-u-margin-bottom-3">No message plans found for this team.</p>
          )}
        </>
      </Card>
    </Container>
  );
}

export default TeamRoutingPlansPage;
